import { useEffect, useState } from "react";
import { LiaSearchPlusSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import {
  materialInward,
  rawMaterials,
  supplierDieAPI,
  Unit,
} from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import Model from "../../common/Model";
import FormFields from "../../common/FormFields";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import EntityAddModal from "../../common/EntityAddModal";
import Button from "../../common/Button";

const MaterialInward = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    inward_No: 0,
    inward_Date: today,
    skU_No: "",
    supplier_Id: "",
    material_Id: "",
    weight_Sleep1: "",
    weight_Sleep2: "",
    quantity: "",
    unit_Id: "",
    rate: "",
    origin: "",
    invoice_No: "",
    grade: "",
    batch_No: "",
    vehicle_No: "",
    notes: "",
    image_Upload: null,
    created_By: 1,
  });

  const [loading, setLoading] = useState(false);
  const [isMaterialInwardData, setIsMaterialInwardData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isSupplierData, setIsSupplierData] = useState([]);
  const [isRawMaterialData, setIsRawMaterialData] = useState([]);
  const [isUnitData, setIsUnitData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const pageSize = 10;
  const [modalType, setModalType] = useState(null);

  const fetchLocationData = async () => {
    setLoading(true);
    try {
      const res = await materialInward.getAllmaterialInward(
        currentPage,
        pageSize
      );
      setIsMaterialInwardData(res.items || []);
      setFilteredData(res.data || []);
      setTotalRecords(res.totalCount || res.data?.length || 0);
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [rawMaterialRes, supplierRes, unitRes] = await Promise.all([
          rawMaterials.getAll(),
          supplierDieAPI.getAll(),
          Unit.getAll(),
        ]);

        setIsRawMaterialData(
          Array.isArray(rawMaterialRes)
            ? rawMaterialRes
            : rawMaterialRes?.data || []
        );

        const supplierArray = Array.isArray(supplierRes?.data)
          ? supplierRes.data
          : [];
        setIsSupplierData(supplierArray);

        setIsUnitData(Array.isArray(unitRes) ? unitRes : unitRes?.data || []);
      } catch (error) {
        notify("Error fetching dropdown data", "error");
      }
    };

    fetchDropdownData();
  }, []);

  useEffect(() => {
    fetchLocationData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isMaterialInwardData);
    } else {
      const filtered = isMaterialInwardData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isMaterialInwardData]);

  const handleInputChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleAdd = () => {
    setIsModelOpen(true);
    setIsEditing(false);
    setFormData({
      inward_No: 0,
      inward_Date: today,
      skU_No: "",
      supplier_Id: "",
      material_Id: "",
      weight_Sleep1: "",
      weight_Sleep2: "",
      quantity: "",
      unit_Id: "",
      rate: "",
      origin: "",
      invoice_No: "",
      grade: "",
      batch_No: "",
      vehicle_No: "",
      notes: "",
      image_Upload: null,
      created_By: 1,
    });
  };

  const handleEdit = async (id) => {
    try {
      const data = await materialInward.getById(id);

      if (data) {
        setFormData({
          inward_No: data.inward_No,
          inward_Date: data.inward_Date?.split("T")[0],
          skU_No: data.skU_No,
          supplier_Id: data.supplier_Id,
          material_Id: data.material_Id,
          weight_Sleep1: data.weight_Sleep1,
          weight_Sleep2: data.weight_Sleep2,
          quantity: data.quantity,
          unit_Id: data.unit_Id,
          rate: data.rate,
          origin: data.origin,
          invoice_No: data.invoice_No,
          grade: data.grade,
          batch_No: data.batch_No,
          vehicle_No: data.vehicle_No,
          notes: data.notes,
          image_Upload: data.image_Upload,
          created_By: 1,
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (error) {
      notify("Failed to fetch location details", "error");
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await materialInward.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchLocationData();
    } catch (error) {
      notify("Failed to delete record", "error");
    }
    setIsDeleteModalOpen(false);
    setSelectedId(null);
  };

  const handleSubmit = async ({ resetOnly = false }) => {
    try {
      const payload = {
        ...formData,
        material_Id: parseInt(formData.material_Id),
        supplier_Id: parseInt(formData.supplier_Id),
        unit_Id: parseInt(formData.unit_Id),
      };
      await materialInward.saveOrUpdate(payload);
      notify(
        isEditing ? "Updated successfully" : "Added successfully",
        "success"
      );
      fetchLocationData();
      setFormData("");
      setIsEditing(false);
      if (!resetOnly) {
        setIsModelOpen(false);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    }
  };

  const fields = [
    {
      name: "inward_Date",
      label: "Inward Date",
      type: "date",
      required: true,
      errorMessage: "Name is required",
    },
    {
      name: "skU_No",
      label: "SKU No",
      type: "text",
      readOnly: true,
    },
    {
      name: "supplier_Id",
      label: "Supplier Name",
      type: "selectWithAdd",
      required: true,
      options: isSupplierData?.map((s) => ({
        value: s.supplier_Id,
        label: s.supplier_Name,
      })),
      onAddNew: () => setModalType("supplier"),
      errorMessage: "Supplier Name is required",
    },
    {
      name: "material_Id",
      label: "Material Name",
      type: "selectWithAdd",
      required: true,
      options: isRawMaterialData?.map((s) => ({
        value: s.id,
        label: s.name,
      })),
      onAddNew: () => setModalType("rawMaterial"),
      errorMessage: "Material Name is required",
    },
    {
      name: "weight_Sleep1",
      label: "Weight Sleep1",
      type: "text",
    },
    {
      name: "weight_Sleep2",
      label: "Weight Sleep2",
      type: "text",
    },
    {
      name: "quantity",
      label: "Quantity",
      type: "number",
      required: true,
      errorMessage: "Quantity is required",
    },
    {
      name: "unit_Id",
      label: "Unit Name",
      type: "selectWithAdd",
      required: true,
      options: isUnitData?.map((s) => ({
        value: s.unit_Id,
        label: s.unit_Name,
      })),
      onAddNew: () => setModalType("unit"),
      errorMessage: "Unit Name is required",
    },
    {
      name: "rate",
      label: "Rate",
      type: "number",
      required: true,
      errorMessage: "Rate is required",
    },
    {
      name: "origin",
      label: "Origin",
      type: "text",
    },
    {
      name: "invoice_No",
      label: "Invoice No",
      type: "text",
    },
    {
      name: "grade",
      label: "Grade",
      type: "text",
    },
    {
      name: "batch_No",
      label: "Batch No",
      type: "text",
    },

    {
      name: "vehicle_No",
      label: "Vehicle No",
      type: "text",
    },

    {
      name: "notes",
      label: "Notes",
      type: "textarea",
    },
    {
      name: "image_Upload",
      label: "Image Upload",
      type: "image",
    },
  ];

  const optionMap = {
    supplier: {
      setter: setIsSupplierData,
      fetcher: supplierDieAPI.getAll,
      mapFn: (data) =>
        data?.map((c) => ({
          value: c.supplier_Id,
          label: c.supplier_Name,
        })),
      setField: "supplier_Id",
    },
    rawMaterial: {
      setter: setIsRawMaterialData,
      fetcher: rawMaterials.getAll,
      mapFn: (data) =>
        data?.map((s) => ({
          value: s.id,
          label: s.name,
        })),
      setField: "id",
    },
    unit: {
      setter: setIsUnitData,
      fetcher: Unit.getAll,
      mapFn: (data) =>
        data?.map((s) => ({
          value: s.unit_Id,
          label: s.unit_Name,
        })),
      setField: "unit_Id",
    },
  };

  const handleEntityAddSuccess = async (type, newOption) => {
    const config = optionMap[type];
    if (!config) return;

    try {
      const response = await config.fetcher();
      const items = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
        ? response.data
        : [];

      config.setter(items);

      setFormData((prev) => ({
        ...prev,
        [config.setField]: newOption?.value || "",
      }));
      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };

  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    try {
      return new Date(isoString).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (e) {
      console.error("Error formatting date:", e);
      return "Invalid Date";
    }
  };

  const generateSupplierInitials = (name) => {
    if (!name || !name.trim()) return "SUPP";
    const initials = name
      .split(" ")
      .map((word) => word[0] || "")
      .join("")
      .toUpperCase()
      .slice(0, 4);
    return initials || "SUPP";
  };

  const formatDateForSku = (isoDate) => {
    try {
      const d = new Date(isoDate);
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      return `${day}${month}`;
    } catch {
      return "XXXX";
    }
  };

  const formatInvoiceForSku = (invoiceNo) => {
    if (!invoiceNo || !invoiceNo.trim()) return "";
    const match = invoiceNo.replace(/[^0-9]/g, "");
    return match ? `-${match}` : "";
  };

  const generateScrapSku = (supplierName, dateReceivedIso, invoiceNo) => {
    const initials = generateSupplierInitials(supplierName);
    const datePart = formatDateForSku(dateReceivedIso);
    const invoicePart = formatInvoiceForSku(invoiceNo);
    return `${initials}${datePart}${invoicePart}`;
  };
  useEffect(() => {
    const supplierObj = isSupplierData.find(
      (s) => String(s.supplier_Id) === String(formData.supplier_Id)
    );

    if (supplierObj && formData.inward_Date) {
      const sku = generateScrapSku(
        supplierObj.supplier_Name,
        formData.inward_Date,
        formData.invoice_No
      );
      setFormData((prev) => ({
        ...prev,
        skU_No: sku,
      }));
    }
  }, [formData.supplier_Id, formData.inward_Date, formData.invoice_No]);

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5  mt-10 ">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              icon={LiaSearchPlusSolid}
              iconSize="w-5 h-5"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            ></Button>
            {searchQuery && (
              <Button
                icon={MdClose}
                onClick={() => setSearchQuery("")}
                iconSize="w-5 h-5"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              ></Button>
            )}
          </div>
          <Button
            text="Add Material Inward"
            className="bg-orange text-black font-semibold text-md rounded-md p-2"
            icon={HiOutlinePlus}
            iconColor="text-black"
            iconSpacing="pr-2"
            padding="p-2"
            onClick={handleAdd}
          />
        </div>

        {loading ? (
          <Loader />
        ) : (
          <Table
            columns={[
              {
                key: "inward_Date",
                label: "Inward Date",
                render: (value) => formatDate(value),
              },
              { key: "skU_No", label: "SKU No" },
              { key: "supplier_Name", label: "Supplier Name" },
              { key: "material_Name", label: "Material Name" },
              { key: "quantity", label: "Quantity" },
              { key: "unit_Name", label: "Unit" },
              { key: "rate", label: "Rate" },
              { key: "origin", label: "Origin" },
              { key: "invoice_No", label: "Invoice No" },
              { key: "grade", label: "Grade" },
              { key: "batch_No", label: "Batch No" },
              { key: "vehicle_No", label: "Vehicle No" },
              { key: "notes", label: "notes" },
            ]}
            data={filteredData}
            onEdit={(row) => handleEdit(row.inward_No)}
            onDelete={(row) => handleDelete(row.inward_No)}
          />
        )}

        <div className="flex justify-center items-center mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize)}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>

      <Model
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        name={isEditing ? "Edit Material Inward" : "Add Material Inward"}
      >
        <FormFields
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: false });
          }}
          onSubmitAndAddNew={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: true });
          }}
          setIsModelOpen={setIsModelOpen}
          formData={formData}
          handleInputChange={handleInputChange}
          fields={fields}
          isEditing={isEditing}
          onClear={() => setIsModelOpen(false)}
        />
      </Model>
      <Model
        isOpen={!!modalType}
        onClose={() => setModalType(null)}
        name={`Add ${modalType}`}
      >
        <EntityAddModal
          type={modalType}
          onClose={(newOption) => {
            setModalType(null);
            handleEntityAddSuccess(modalType, newOption);
          }}
        />
      </Model>
      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </>
  );
};

export default MaterialInward;
